"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userAgent = exports.userAgentData = void 0;
exports.userAgentData = (typeof window !== "undefined" && window.navigator && "userAgentData" in window.navigator)
    ? window.navigator.userAgentData
    : null;
exports.userAgent = (typeof window !== "undefined" && window.navigator && window.navigator.userAgent)
    ? window.navigator.userAgent
    : null;
